'use strict';

var widgetsTemplates = require('./templates_widgets_name');
var widgetsWithoutVariableInTemplatesSettings = ['edit_option_meta', 'shared_legal_disclaimer'];
var STATUS = {
    pending: 'pending',
    ready: 'ready',
};
var loadedTemplates = {
    templates: {},
};
var getUrl = function(service, queryValue, templates) {
    return Odigeo.Settings.options.templatesMethodFormatter(service) + '?' + queryValue + '=' + templates;
};
var setTemplates = function(returnedTemplate, callback) {
    var templatesList = {
        templates: {},
        keys: {},
    };

    if (_.isObject(returnedTemplate)) {
        _.each(returnedTemplate.templates, function(template) {
            templatesList.templates[template.name] = _.template(template.html, Odigeo.Utils.getTmplSettings(
                {variable: _.includes(widgetsWithoutVariableInTemplatesSettings, returnedTemplate.name) ? '' : 'data'}
            ));
        });

        _.each(returnedTemplate.cmsKeys, function(cmsKey) {
            templatesList.keys[cmsKey.name] = cmsKey.value;
        });

        if (_.isFunction(callback)) {
            callback(returnedTemplate.name, templatesList);
        }
    }

    return templatesList;
};
var setWidgetTemplate = function(templateName, templatesList) {
    loadedTemplates[templateName] = {
        data: templatesList,
        status: STATUS.ready,
    };
};
var setStaticTemplate = function(templateName, templatesList) {
    loadedTemplates.templates.data[templateName] = templatesList;
};
var serviceUrl = {
    widgetAllTemplates: _.partial(getUrl, 'getWidgetTemplates', 'widgetname', _),
    listOfWidgetsAllTemplates: _.partial(getUrl, 'getListOfWidgetsTemplates', 'widgetsnames', _),
};
var requestTemplates = function(templateNames, serviceRequest) {
    var templatesNamesList = !_.isEmpty(templateNames) ? templateNames.split(',') : [];
    var d = $.Deferred();
    _.each(templatesNamesList, function(templateName) {
        loadedTemplates[templateName] = {
            data: d,
            status: STATUS.pending,
        };
    });

    $.get(serviceUrl[serviceRequest](templateNames))
        .pipe(function(response) {
            d.resolve(response);
        })
        .fail(function() {
            d.resolve(null);
        });


    return d.promise();
};
var getTemplate = function(templateName, serviceOption) {
    var d = $.Deferred();

    if (!loadedTemplates[templateName]) {
        requestTemplates(templateName, serviceOption).then(function(template) {
            d.resolve(setTemplates(template, setWidgetTemplate));
        });
    } else if (loadedTemplates[templateName].status === STATUS.pending) {
        loadedTemplates[templateName].data.then(function(templates) {
            d.resolve(templates);
        });
    } else {
        d.resolve(loadedTemplates[templateName].data);
    }
    return d.promise();
};
var getStaticTemplates = function(staticTemplatesList) {
    var d = $.Deferred();

    var filterStaticTemplates = function(staticTemplatesList) {
        var requestedTemplates = _.pick(loadedTemplates.templates.data, function(value, index) {
            return staticTemplatesList.indexOf(index) !== -1;
        });

        var templates = {};
        _.each(requestedTemplates, function(value, key) {
            templates[key] = value.templates;
        });

        return templates;
    };

    if (loadedTemplates.templates.status === STATUS.pending) {
        loadedTemplates.templates.data.then(function(responseOK) {
            if (responseOK) {
                d.resolve(filterStaticTemplates(staticTemplatesList));
            } else {
                d.resolve(null);
            }
        });
    } else {
        d.resolve(filterStaticTemplates(staticTemplatesList));
    }
    return d.promise();
};
var getTemplates = function(templateList, serviceOption) {
    var templatesNotLoaded = [];
    var templatesPending = [];
    var d = $.Deferred();

    loadedTemplates.templates = {
        data: $.Deferred(),
        status: STATUS.pending,
    };

    _.each(templateList, function(templateName) {
        if (!loadedTemplates[templateName]) {
            templatesNotLoaded.push(templateName);
        } else if (loadedTemplates[templateName].status === STATUS.pending) {
            templatesPending.push(
                loadedTemplates[templateName].data.then(function(templates) {
                    d.resolve(templates);
                })
            );
        }
    });

    $.when.apply($, [requestTemplates(templatesNotLoaded.join(','), serviceOption)].concat(templatesPending))
        .done(function(promisesResults) {
            var staticPromise = loadedTemplates.templates.data;
            var widgetTemplates = _.get(promisesResults, 'widgetTemplates');
            var staticTemplates = _.get(promisesResults, 'templates');
            var isResponseOK = _.isArray(widgetTemplates) && _.isArray(staticTemplates);

            if (isResponseOK) {
                loadedTemplates.templates.data = {};
                _.each(staticTemplates, function(template) {
                    setTemplates(template, setStaticTemplate);
                });
                loadedTemplates.templates.status = STATUS.ready;

                _.each(templatesNotLoaded, function(name) {
                    setTemplates(_.find(widgetTemplates, {'name': name}), setWidgetTemplate);
                });
            }

            staticPromise.resolve(isResponseOK);
            d.resolve(isResponseOK);
        });

    return d.promise();
};

module.exports = {
    init: function() {
        var sessionScope = Odigeo.SessionScope;
        var flow = sessionScope.flow;
        var entryPoint = sessionScope.entryPoint;
        var flowProduct = sessionScope.flowProduct;
        var templates = widgetsTemplates[flow][flowProduct][entryPoint];

        this.getListOfWidgetsTemplates(templates);
    },
    /**
     * Service to get templates from an specific widget
     * @param {String} name
     * @return {Object}
     */
    getWidgetTemplate: function(name) {
        return getTemplate(name, 'widgetAllTemplates');
    },
    /**
     * Service to get templates from a list of widgets
     * @param {Array<String>} templatesList
     * @return {boolean}
     */
    getListOfWidgetsTemplates: function(templatesList) {
        return getTemplates(templatesList, 'listOfWidgetsAllTemplates');
    },
    /**
     * Is template already loaded
     * @param {String} name
     * @return {boolean}
     */
    isTemplatesLoaded: function(name) {
        return _.isObject(loadedTemplates[name]) && loadedTemplates[name].status === STATUS.ready;
    },
    /**
     * Service to get a static template
     * @param {String[]} staticTemplatesList
     * @return {Array<Object>}
     */
    getGenericTemplates: function(staticTemplatesList) {
        return getStaticTemplates(staticTemplatesList);
    },
};
